import React, { useEffect } from "react";
import { Select } from "antd";
import { Modal } from "react-bootstrap";
//css
import "./Modal.css";
import { Form } from "react-bootstrap";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import BtnSave from "../Commons/Buttons/BtnSave";
import TextArea from "../Commons/Forms/TextArea";
import { getRole, getUser } from "../Helpers/Utilities/Common";
import TextField from "../Commons/Forms/TextField";

const { Option } = Select;

function EditQueueModal(props) {
  const role = getRole();
  const userId = getUser();

  useEffect(() => {
    if(role !== "nurse"){
    props.setSelectedDoctor(userId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="row">
            <Form.Label className="form-title align-center">
              Edit Queue Details
            </Form.Label>
          </div>

          <div className="row mt-2 mb-1">
            <TextField
              id="patient_name"
              type={``}
              formLabel={`Patient Name`}
              size={`sm`}
              name="patient_name"
              value={props?.queueDetails?.patient_name}
              disabled={true}
            />
          </div>

          {/*if user is admin/resident, no need to select doctor.*/}
          {role === "nurse" && (
            <>
              <div className="row custom-dropdown">
                <span>Doctor <label className="red"> *</label></span>
                <Select
                  placeholder="Select Doctor"
                  onChange={props.setSelectedDoctor} // Directly update state
                  value={props.selectedDoctor} // Use selected doctor
                  allowClear
                  options={props.doctorsData}
                  optionFilterProp="label"
                  showSearch
                />
              </div>
            </>
          )}
          <div className="row mt-2">
            <TextArea
              required={true}
              name="complaint"
              formLabel={`Chief Complaint`}
              value={props?.complaint?.toUpperCase()}
              onChange={props.onChange}
            />
          </div>

          <div className="row mt-4 right">
            <div className="col-6">
              <BtnDelete
                label={"Close"}
                size={"sm"}
                onClick={props.onHide}
                isClicked={props.isClicked}
              />
            </div>
            <div className="col-6">
              <BtnSave
                label={"Save Changes"}
                size={"sm"}
                onClick={props.onConfirm}
                isClicked={props.isClicked}
                disabled={props.complaint === "" || props.doctor_id === ""}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default EditQueueModal;
